import { useCallback, useMemo, useState } from 'react';
// const {AppComp} = require('../comp/antd');
import { useRoutes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import routeArr from '@/config/router';
import './App.css';
function App() {
  const routes = useRoutes(routeArr);
  return <ConfigProvider locale={zhCN}>{routes}</ConfigProvider>;
}

export default App;
